export enum GrpSubMenusPathEnum {
    LAYERS = "camadas",
    LAYERS_GROUPS = "grupo-camadas",
    LAYERS_STYLES = "estilos-camadas",
    ACESSO_WEBGEO = "acessos-webgeo",
    USERS = "usuarios",
    ROLES = "grupos",
    LOGS = "logs",
    DASHBOARD = "",
    ACESSO_GRP = "acessos-grp",
    LIST_GOALS = "list-goals",
    STEPS = "steps",
    SECRETARIES = "secretaries",
    ZONING = "zoneamento",
    ZONING_USE_OCCUPATION = "zoneamento-uso-ocupacao",
    ANY_SEARCH = "any_search",
}

export enum GrpModulesPathEnum {
    GRP = "grp-config",
    WEBGEO = "webgeo",
    PROJECTS = "projetos",
    GOV_PLAN = "plano-de-governo",
    HOME = "",
}

export enum GrpMenusPathEnum {
    CONFIG_WEBGEO = "config_webgeo",
    WEBGEO_ACCESS = "webgeo_access",
    WEBGEO_LOGS = "webgeo_logs",
    GRP_ACCESS = "grp_access",
    GRP_LOGS = "grp_logs",
    GOV_GOALS = "gov_goals",
    WEBGEO_ZONING = "webgeo_zoning",
    WEBGEO_ZONING_USE_OCCUPATION = "webgeo_zoning_use_occupation",
    WEBGEO_ANY_SEARCH = "webgeo_any_search",
}
